import { XIcon } from "@phosphor-icons/react/dist/csr/X";
import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import type { StatementItemReference } from "@/payroll/ai-script/statement/statement-renderer";
import { referenceParts } from "@/payroll/pack-chat/reference-label";

/** The selected PayPack figure as it will read at the top of the new thread. */
export const AttachedStatementItem = ({
  item,
  onRemove,
}: {
  item: StatementItemReference;
  onRemove: () => void;
}) => {
  const { path, label, value, valueIsFigure } = referenceParts(item);
  const details = [path, valueIsFigure ? undefined : value]
    .filter(Boolean)
    .join(" · ");

  return (
    <Stack
      direction="row"
      align="center"
      justify="between"
      gap={4}
      className="w-full border-b border-line pb-3"
    >
      <Stack gap={0} align="stretch" className="min-w-0">
        <Text
          variant="caption"
          tone="muted"
          className="font-medium tracking-widest uppercase"
        >
          Asking about
        </Text>
        <Text variant="label" className="truncate" title={label}>
          {label}
        </Text>
        {details && (
          <Text
            variant="caption"
            tone="muted"
            className="truncate"
            title={details}
          >
            {details}
          </Text>
        )}
      </Stack>
      <Stack direction="row" align="center" gap={2} className="shrink-0">
        {value && valueIsFigure && <Text variant="title">{value}</Text>}
        <Button
          type="button"
          variant="ghost"
          size="icon-xs"
          onClick={onRemove}
          aria-label="Remove the attached figure"
          className="rounded-full text-subtle"
        >
          <XIcon className="size-4" aria-hidden />
        </Button>
      </Stack>
    </Stack>
  );
};
